// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"f3f25574","58":"08c6fede","348":"a9aa166e","354":"d6d9a378","390":"212012b2","457":"d8104c27","463":"c04e089d","510":"58bacf2b","844":"0d49f835","845":"daff0870","886":"ca013bb5","897":"675bd58f","900":"61771631","932":"1545cc56"}[chunkId] + ".chunk.js";
};